export const GENDERS = [
  { value: "M", label: "Homme", icon: "fas fa-mars", color: "info" },
  { value: "F", label: "Femme", icon: "fas fa-venus", color: "danger" },
]

export const GENDER_OPTIONS = [
  { value: null, label: "Tous", icon: "fas fa-users" },
  ...GENDERS,
]

export const GENDER_LABELS = Object.fromEntries(
  GENDERS.map(({ value, ...rest }) => [value, rest])
)

export const AGE_RANGES = [
  { value: "0-12", label: "0-12 ans" },
  { value: "13-17", label: "13-17 ans" },
  { value: "18-24", label: "18-24 ans" },
  { value: "25-34", label: "25-34 ans" },
  { value: "35-44", label: "35-44 ans" },
  { value: "45-54", label: "45-54 ans" },
  { value: "55-64", label: "55-64 ans" },
  { value: "65+", label: "65+ ans" },
]
